var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.712 18.696a1.03 1.03 0 0 0 0-1.459L10.475 12l5.237-5.237a1.031 1.031 0 0 0-1.458-1.458L8.288 11.27a1.03 1.03 0 0 0 0 1.458l5.966 5.966a1.03 1.03 0 0 0 1.458 0"
  })));
};
export default SvgChevronLeft;